// Trade-capabilities probe. Kept free of the TON crypto stack on purpose:
// the wallet/vault modules pull @ton/core + @ton/crypto (~700KB minified),
// and this probe runs on the app boot path (WalletsProvider, ProfilePopover),
// so it must not drag that chunk into first paint.

import { apiFetch } from '../api/client'

export type TradeCapabilities = {
  quoteEnabled: boolean
  supportedVenues: string[]
  signingEnabled: boolean
  executionEnabled: boolean
  walletManagementEnabled: boolean
  walletExportEnabled: boolean
  loginEnabled: boolean
  registrationEnabled: boolean
}

/** Reads the server-owned split between planning and money execution. */
export async function probeTradeCapabilities(): Promise<TradeCapabilities> {
  try {
    const response = await apiFetch<{
      quote_enabled: boolean
      supported_venues?: unknown
      signing_enabled: boolean
      execution_enabled: boolean
      wallet_management_enabled: boolean
      wallet_export_enabled: boolean
      login_enabled: boolean
      registration_enabled: boolean
    }>('/v1/userland/trade-capabilities', { cache: 'no-store' })
    return {
      quoteEnabled: response.quote_enabled === true,
      supportedVenues: Array.isArray(response.supported_venues)
        ? response.supported_venues.filter(
            (venue): venue is string => typeof venue === 'string' && venue.length > 0
          )
        : [],
      signingEnabled: response.signing_enabled === true,
      executionEnabled: response.execution_enabled === true,
      walletManagementEnabled: response.wallet_management_enabled === true,
      walletExportEnabled: response.wallet_export_enabled === true,
      loginEnabled: response.login_enabled === true,
      registrationEnabled: response.registration_enabled === true,
    }
  } catch {
    // An absent or unhealthy capability endpoint is never a green light.
    return {
      quoteEnabled: false,
      supportedVenues: [],
      signingEnabled: false,
      executionEnabled: false,
      walletManagementEnabled: false,
      walletExportEnabled: false,
      loginEnabled: false,
      registrationEnabled: false,
    }
  }
}
